import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  recommendedListing: generateApiPath({ prefix: AuthLevel.AUTH, name: 'recommended-listing' }),
}

export { paths }
